import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Observable, Subscription } from 'rxjs';

import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../security.module.config';
import { AddRoleModel } from '../models/AddRoleModel';
import { LookupModel } from '../../common/models/LookupModel';
import { LookupService } from '../../core/services/index';
import { SystemRoleType } from '../models/SystemRoleType';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-add-role-dialog',
  templateUrl: './add-role-dialog.component.html',
  styleUrls: ['./add-role-dialog.component.scss']
})
export class AddRoleDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  eventUnsubscribe: Subscription;
  errors$: Observable<string[]>;
  roleTypes: LookupModel[];

  constructor(private store: Store<any>,
              public dialogRef: MatDialogRef<AddRoleDialogComponent>,
              private formBuilder: FormBuilder,
              private router: Router,
              private actions$: Actions,
              private lookupService: LookupService) {
    this.addForm = formBuilder.group({
      type: ['', Validators.required],
      name: ['', Validators.required],
      description: ['', Validators.required]
    });

    this.roleTypes = lookupService.lookupsForEnums(SystemRoleType);
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.addSuccessType<AddRoleModel>(ModuleConfiguration.moduleName, AddRoleModel))
      .subscribe((a: actions.AddSuccessAction<AddRoleModel>) => {
        this.router.navigateByUrl('role-workspace/' + a.payload.key);
        this.close();
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }

  add() {
    this.store.dispatch(new actions.AddAction(ModuleConfiguration.moduleName, AddRoleModel, { model: this.addForm.value }));
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/security/components/add-role-dialog.component.ts